import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { TranslationService } from '../../../Services/translation.service';
import { VenueListingItem } from '../../../models/listing';
import { HelperService } from "../../../Services/helper.service";
import { SwiperContainer } from 'swiper/element';
import { SwiperOptions } from 'swiper/types';


@Component({
  selector: 'app-homelastadded',
  templateUrl: './homelastadded.component.html',
  styleUrls: ['./homelastadded.component.css']
})

export class HomelastaddedComponent implements OnInit {

  @Input() newlyAdded: VenueListingItem[] = [];
  loaded: boolean = false;
  word: any = {};
  language: string = '';
  config: SwiperOptions = {
    init: true,
    navigation: {
      prevEl: '#prev-added',
      nextEl: '#next-added'
    },
    slidesPerView: 5.6,
    breakpoints: {
      '320': {
          slidesPerView: 1.5

        },
        '420': {
          slidesPerView: 1.9

        },
        '580': {
          slidesPerView: 2.8
        },
        '768': {
          slidesPerView: 3.5
        },
        '991': {
          slidesPerView: 4.7
        },
        '1280':{
          slidesPerView: 5.6
        }
    }
  }

  @ViewChild('lastAddedSlider') swiper!: ElementRef<SwiperContainer>;

  constructor(private helperService: HelperService,
    private translationService: TranslationService) {
      this.word = this.translationService.word;
      this.language = this.translationService.language;
    }

  ngOnInit(): void {
    this.loaded = true;
  }
  ngAfterViewInit(): void{
    Object.assign(this.swiper, this.config);
    this.swiper.nativeElement.initialize();
  }
  toLatin(word: string): string {
    return word = this.helperService.toLatin(word);
  }
}
